import Vue from 'vue';
import { capitalize } from './stringFormating.js';

export * from './clone';

Vue.filter('capitalize', capitalize);
